import type { UserOverridesItemRequest } from 'js/src/client';
import type { UserOverrides } from 'js/src/data/user-overrides';
import { DEFAULT_USER_OVERRIDES } from 'js/src/data/user-overrides';
import type { RootState } from 'js/src/libs/RootState';

export function getUserOverrides(state: RootState): UserOverrides {
    return state.undoable.present.user_overrides;
}

export function getSlideOverrides(
    state: RootState,
    sceneId: string,
): UserOverridesItemRequest | undefined {
    return (state as Partial<RootState>).undoable?.present?.user_overrides?.[sceneId];
}

export function getAssetsWithTimesOverridden(state: RootState, sceneId: string): string[] {
    return getSlideOverrides(state, sceneId)?.asset_timing_overrides || [];
}

export function isAssetTimingOverridden(
    state: RootState,
    sceneId: string,
    assetId: string,
): boolean {
    return getAssetsWithTimesOverridden(state, sceneId).includes(assetId);
}

export function isTextPositionUserOverridden(state: RootState, sceneId: string): boolean {
    return getSlideOverrides(state, sceneId)?.text_position ?? DEFAULT_USER_OVERRIDES.TEXT_POSITION;
}

export function isTextAlignmentUserOverridden(state: RootState, sceneId: string): boolean {
    return (
        getSlideOverrides(state, sceneId)?.text_alignment ?? DEFAULT_USER_OVERRIDES.TEXT_ALIGNMENT
    );
}

export function isSceneDurationUserOverridden(state: RootState, sceneId: string): boolean {
    return getSlideOverrides(state, sceneId)?.duration ?? DEFAULT_USER_OVERRIDES.DURATION;
}

export function isCropUserOverridden(state: RootState, sceneId: string): boolean {
    return (
        getSlideOverrides(state, sceneId)?.background_transform ??
        DEFAULT_USER_OVERRIDES.BACKGROUND_TRANSFORM
    );
}

export function isKenburnUserOverridden(state: RootState, sceneId: string): boolean {
    return (
        getSlideOverrides(state, sceneId)?.background_animation ??
        DEFAULT_USER_OVERRIDES.BACKGROUND_ANIMATION
    );
}

export function isBrightnessUserOverridden(state: RootState, sceneId: string): boolean {
    return getSlideOverrides(state, sceneId)?.brightness ?? DEFAULT_USER_OVERRIDES.BRIGHTNESS;
}

export function isBackgroundColorUserOverridden(state: RootState, sceneId: string): boolean {
    return (
        getSlideOverrides(state, sceneId)?.background_color ??
        DEFAULT_USER_OVERRIDES.BACKGROUND_COLOR
    );
}
